<template>
	<footer class="footer">
		<div class="footer_container">
			<div class="footer_item item-left">
				<div>
					<p class="footer_plain-text">123056, г. Москва, ул. Красина, д. 27, стр. 2, эт. 1, пом. XV, ком. 1</p>
					<p class="footer_plain-text">Тел.: +7 (499) 254-91-30</p>
					<p class="footer_plain-text">
						E-mail:
						<a class="link" href="mailto:av@gamma-press.ru">av@gamma-press.ru</a>
						<!-- <a class="link" href="mailto:av@gamma-press.com">av@gamma-press.com</a> -->
					</p>
				</div>
			</div>

			<div class="footer_item item-center">
				<div>
					<p class="footer_plain-text"></p>
				</div>
			</div>

			<div class="footer_item item-right">
				<div>
					<p class="footer_plain-text">© ООО «ГАММА-ПРЕСС», 2019</p>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
export default {
	data() {
		return {};
	}
};
</script>

<style lang="scss" scoped>
@import "~styles/_vars.scss";

.footer {
	padding: 4rem 11vw;
	background: linear-gradient(
		to bottom right,
		$dark 45%,
		darken($dark, 10) 100%
	);
	box-shadow: 0 -6px 12px 0 rgba(#333, 0.5);
	z-index: 1;

	@media screen and (max-width: $desktop-medium) {
		padding: 4rem 6vw;
	}

	@media screen and (max-width: $desktop-small) {
		padding: 4rem 2vw;
	}
}

.footer_container {
	display: flex;
	flex-direction: row;
	justify-content: space-between;

	@media screen and (max-width: $mobile) {
		flex-direction: column;
		align-items: flex-start;
	}
}

.footer_item {
	@media screen and (max-width: $mobile) {
		margin-bottom: 1rem;
	}
}

.item-right {
	text-align: right;
}

.link {
	color: inherit;
	border-bottom-width: 2px;
}

.footer_plain-text {
	margin: 0;
	padding: 0;
	font-size: $text-plain-desktop;
	color: $white;

	@media screen and (max-width: $desktop-medium) {
		font-size: $text-plain-tablet;
	}

	@media screen and (max-width: $mobile) {
		font-size: $text-plain-mobile;
	}
}
</style>



// WEBPACK FOOTER //
// client/components/Footer.vue